import React from "react";
import Logo from "@/components/Logo";
import { BRAND } from "@/data";

export default function Footer() {
  return (
    <footer
      className="relative z-10 bg-[#14171A] border-t border-[#A8AEB2]/15"
      data-testid="footer"
    >
      {/* Giant brand wordmark */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-10 overflow-hidden">
        <h2 className="font-display uppercase text-[22vw] md:text-[15vw] leading-[0.8] text-[#1E2227] select-none">
          GORMANS
        </h2>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-t border-[#A8AEB2]/15 pt-10">
        <Logo />
        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-10">
          <a
            href={BRAND.phoneHref}
            className="font-body text-[#A8AEB2] hover:text-[#7AB648] transition-colors"
            data-testid="footer-phone"
          >
            {BRAND.phone}
          </a>
          <a
            href={`mailto:${BRAND.email}`}
            className="font-body text-[#A8AEB2] hover:text-[#7AB648] transition-colors"
            data-testid="footer-email"
          >
            {BRAND.email}
          </a>
          <span className="font-body text-[#A8AEB2]">{BRAND.area}</span>
        </div>
      </div>

      <div className="border-t border-[#A8AEB2]/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-body text-xs uppercase tracking-widest text-[#A8AEB2]/60">
            © {new Date().getFullYear()} Gormans Contracting. All rights reserved.
          </p>
          <p className="font-body text-xs uppercase tracking-widest text-[#A8AEB2]/60">
            {BRAND.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
